/** Guía pública de Sudefootball Player — paso a paso para familias. Sin auth. */
const VIDEO_URL = ""; // ← pegar aquí el enlace del vídeo tutorial (Loom/YouTube) cuando esté grabado

const PASOS = [
  {
    n: "1",
    t: "Entra con tu cuenta",
    d: "Tras el pago recibes un email con tu usuario y contraseña. Entra en app.sudefootball.sudeporte.com desde el móvil u ordenador. Si no ves el email, revisa spam/promociones.",
  },
  {
    n: "2",
    t: "Crea la ficha de tu hijo/a",
    d: "Nombre, año de nacimiento, posición y dorsal. En menos de 1 minuto tienes su ficha deportiva creada — puedes añadir más de un hijo si tu plan lo incluye.",
  },
  {
    n: "3",
    t: "Registra su primer partido",
    d: "Después de cada partido apunta minutos, goles, asistencias, tarjetas y tus sensaciones. Tarda 1 minuto desde la grada. También puedes registrar entrenos y lesiones.",
  },
  {
    n: "4",
    t: "Mira su progreso",
    d: "Gráficas de evolución de minutos, goles y valoraciones a lo largo de la temporada. Cada temporada queda guardada para siempre: el archivo deportivo completo de tu hijo/a.",
  },
];

const EXTRAS = [
  ["📲 Instala la app en tu móvil", "Abre la web en tu navegador, menú del navegador → \"Añadir a pantalla de inicio\". Se instala como una app normal y abre a pantalla completa."],
  ["⭐ Evaluaciones", "Puntúa técnica, físico y actitud tras cada partido y observa la tendencia mes a mes."],
  ["🩹 Lesiones", "Registra lesiones y recuperaciones: el historial médico-deportivo queda en la ficha."],
  ["🎁 Propón su club — 1 mes gratis", "Si el club de tu hijo/a aún no usa Sudefootball, proponlo desde tu panel. Si el club se suscribe, tu suscripción tiene 1 mes gratis."],
];

export default function PublayerGuidePage() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <div className="max-w-3xl mx-auto px-5 py-10 sm:py-14">
        <div className="text-[11px] font-heading font-black uppercase tracking-[0.25em] text-red-600" data-testid="pg-kicker">Sudefootball Player · Guía rápida</div>
        <h1 data-testid="pg-title" className="mt-3 text-4xl sm:text-5xl font-black tracking-tighter uppercase leading-[0.95]">
          Empieza en <span className="text-red-600">5 minutos</span>
        </h1>
        <p className="mt-4 text-slate-600 text-base max-w-xl">
          Sudefootball Player es el archivo deportivo de tu hijo/a: partidos, minutos, goles, evaluaciones y progreso — temporada tras temporada, por 12 €/año.
        </p>

        {VIDEO_URL && (
          <div className="mt-8 border-2 border-slate-200" data-testid="pg-video">
            <div className="aspect-video">
              <iframe src={VIDEO_URL} title="Vídeo tutorial Sudefootball Player" className="w-full h-full" allowFullScreen />
            </div>
          </div>
        )}

        <div className="mt-10 space-y-5" data-testid="pg-steps">
          {PASOS.map((p) => (
            <div key={p.n} className="flex gap-4 border-2 border-slate-200 p-5">
              <div className="w-10 h-10 shrink-0 bg-red-600 text-white font-black text-xl flex items-center justify-center">{p.n}</div>
              <div>
                <div className="font-heading font-black uppercase tracking-tight text-lg">{p.t}</div>
                <p className="text-sm text-slate-600 mt-1 leading-relaxed">{p.d}</p>
              </div>
            </div>
          ))}
        </div>

        <h2 className="mt-12 text-base md:text-lg font-black uppercase tracking-tight" data-testid="pg-extras-title">Y además…</h2>
        <div className="mt-4 grid sm:grid-cols-2 gap-4">
          {EXTRAS.map(([t, d]) => (
            <div key={t} className="border border-slate-200 p-4">
              <div className="font-heading font-bold text-sm">{t}</div>
              <p className="text-xs text-slate-600 mt-1 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-slate-900 text-white p-6 sm:p-8" data-testid="pg-cta">
          <div className="font-heading font-black uppercase tracking-tight text-xl">¿Listo? Entra y registra su primer partido</div>
          <p className="text-sm text-slate-300 mt-1">Cualquier duda, escríbenos y te ayudamos en el día.</p>
          <div className="mt-4 flex flex-wrap gap-3">
            <a href="/login" data-testid="pg-login-btn" className="inline-flex items-center h-12 px-6 bg-red-600 hover:bg-red-700 text-white font-heading font-black uppercase tracking-wider text-sm">Entrar en mi cuenta</a>
            <a href="mailto:sudefootball@sudeporte.com" data-testid="pg-contact-btn" className="inline-flex items-center h-12 px-6 border-2 border-white/40 hover:border-white text-white font-heading uppercase tracking-wider text-sm">Escribir a soporte</a>
          </div>
        </div>

        <p className="mt-8 text-center text-[11px] text-slate-400 font-mono">Sudefootball Player · by Sudeporte</p>
      </div>
    </div>
  );
}
